<script setup>
import { ref } from "vue";
import CreatePoll from "@/components/CreatePoll.vue";
import ActionButton from "@/components/ui/ActionButton.vue";
import ToggleButton from "@/components/ui/ToggleButton.vue";

const selectedPollType = ref("group");

const handlePollTypeSelect = (type) => {
  selectedPollType.value = type;
};
</script>

<template>
  <div class="bg-gray-50 px-4 py-6 sm:px-6">
    <div class="max-w-7xl mx-auto">
      <div
        class="mb-6 sm:mb-8 flex flex-col gap-4 sm:gap-6 lg:flex-row lg:items-center lg:justify-between"
      >
        <div>
          <h1 class="text-xl sm:text-2xl font-semibold text-neutral-text mb-2">
            Create Poll
          </h1>
          <div class="flex items-center gap-2">
            <span class="text-sm sm:text-base text-neutral-light"
              >Poll Type</span
            >
            <span
              class="bg-primary/10 text-primary-neutral text-xs sm:text-sm font-medium px-2 sm:px-2.5 py-0.5 rounded-full"
            >
              {{ selectedPollType === "group" ? "Group" : "Individual" }}
            </span>
          </div>
        </div>
        <div
          class="flex w-full flex-col gap-2 sm:flex-row sm:flex-wrap sm:gap-3 lg:w-auto lg:justify-end"
        >
          <!-- Back button on its own row on mobile -->
          <router-link
            class="w-full rounded-lg focus:outline-none focus:ring-1 focus:ring-primary sm:w-auto order-3 sm:order-1"
            to="/polls"
          >
            <ActionButton
              action="back"
              class="w-full py-2 text-xs sm:w-auto sm:py-2 sm:text-xs"
            />
          </router-link>
          <!-- Poll type buttons on same row on mobile -->
          <div class="flex gap-2 order-1 sm:order-2 sm:contents">
            <ToggleButton
              :active="selectedPollType === 'individual'"
              class="flex-1 py-2 text-xs min-w-0 sm:flex-none sm:min-w-[160px] sm:py-2 sm:text-sm"
              @click="handlePollTypeSelect('individual')"
            >
              Individual
            </ToggleButton>
            <ToggleButton
              :active="selectedPollType === 'group'"
              class="flex-1 py-2 text-xs min-w-0 sm:flex-none sm:min-w-[160px] sm:py-2 sm:text-sm"
              @click="handlePollTypeSelect('group')"
            >
              Group
            </ToggleButton>
          </div>
        </div>
      </div>
      <CreatePoll :pollType="selectedPollType" />
    </div>
  </div>
</template>
